export const CONTACT_FORM = {
  FAQ: 'FAQ',
  CONTACT_US: 'CONTACT_US',
  MISSING_BAKERY_REPORT: 'MISSING_BAKERY_REPORT',
};

export const POPUP_FORMS = {
  HOW_IT_WORKS: 'HOW_IT_WORKS'
};

export const MODAL_CLOSE_ACTIONS = {
  OPEN_CONTACT_US: 'OPEN_CONTACT_US'
};

export const LAST_SEARCH_PARAMS = 'LAST_SEARCH_PARAMS';
export const LAST_SEARCH_QUERY_PARAMS = 'LAST_SEARCH_QUERY_PARAMS';
export const LAST_SCROLL_Y = 'LAST_SCROLL_Y';

export const CART_SOURCE_TYPE = {
  STANDARD: 'STANDARD',
  EXPRESS: 'EXPRESS'
};

export enum CHECKING_DELIVERY_TYPES {
  DELIVERY = 'DELIVERY',
  PICKUP = 'PICKUP',
  THIRD_PARTY = 'THIRD_PARTY'
}
